/**
 * JavaScript Polyfills
 * According to browserslistrc support
 */
// import 'core-js/modules/es.array.from.js';
//import 'core-js/modules/es.array.find.js';
//import 'core-js/modules/es.array.iterator.js';
//import 'core-js/modules/es.array.includes.js';
//import 'core-js/modules/es.object.assign.js';
//import 'core-js/modules/es.object.entries.js';
//import 'core-js/modules/es.object.values.js';
//import 'core-js/modules/es.string.includes.js';
//import 'core-js/modules/es.symbol.iterator.js';
//import 'core-js/modules/es.promise.js';

/**
 * DOM Polyfills
 */
// ObjectFitImages
import objectFitImages from 'object-fit-images';
import 'whatwg-fetch'; // XHR replacement - Include after promise polyfill
import 'element-polyfill';
import 'element-closest-polyfill';
import 'intersection-observer';
import 'element-matches';
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';

objectFitImages();
window.ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
